import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { Box, CircularProgress, TextField, Typography } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import CandidateListCard from "./CandidateListCard";
import { useEffect, useState } from "react";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import { useDispatch, useSelector } from "react-redux";
import CandidateDetailsViewDrawer from "./CandidateDetailsViewDrawer";
import AddCandidateDrawer from "./AddCandidateDrawer";
import { allSkill } from "../../redux/common/skillSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import InfiniteScroll from "react-infinite-scroll-component";

const CandidateListDrawer = ({ handleClose, show }) => {
  const [submisionRow, setSubmisionRow] = useState({});
  const [showDetails, setShow] = useState(false);
  const [candidateType, setCandidateType] = useState("");
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showAddCandidate, setShowAddCandidate] = useState(false);
  const handleCloseShowAddCandidate = () => setShowAddCandidate(false);
  const handleShowAddCandidate = () => setShowAddCandidate(true);
  const [searchName, setSearchName] = useState("");
  const [page, setPage] = useState(1);
  const [candidates, setCandidates] = useState([]);
  const [hasNext, setHasNext] = useState(false);

  // Reset data when search changes
  useEffect(() => {
    if (searchName) {
      setPage(1);
      setCandidates([]);
      fetchCandidates(searchName, 1);
    } else {
      setPage(1);
      setCandidates([]);
      fetchCandidates("", 1);
    }
  }, [searchName]);

  const dispatch = useDispatch();
  const allCandiadate = useSelector((state) => state.candidate.data);
  const candidateStatus = useSelector((state) => state.candidate.status);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
    dispatch(allSkill());
    dispatch(getAllCandidate());
  }, []);

  const handleOnClickJobID = (row) => {
    handleShow();
    setSubmisionRow(row);
  };

  const handleOnClickEditCandidate = (row) => {
    handleShowAddCandidate();
    setSubmisionRow(row);
    setCandidateType("edit");
  };

  const handleOnClickAddCandidate = () => {
    handleShowAddCandidate();
    setSubmisionRow({});
    setCandidateType("add");
  };

  useEffect(() => {
    if (searchName) {
      let queryString = `full_name=${searchName}`;
      dispatch(getAllCandidate(queryString));
    } else {
      dispatch(getAllCandidate(""));
    }
  }, [searchName]);

  const fetchCandidates = (name = "", pageNumber = 1) => {
    const query = name
      ? `full_name=${name}&page=${pageNumber}`
      : `page=${pageNumber}`;

    dispatch(getAllCandidate(query)).then((res) => {
      if (res.payload?.profiles) {
        setCandidates((prev) =>
          pageNumber === 1
            ? res.payload.profiles
            : [...prev, ...res.payload.profiles]
        );
        setHasNext(res.payload.has_next);
      }
    });
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 10 && hasNext) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchCandidates(searchName, nextPage);
    }
  };


  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "45%",
        padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <IoIosArrowBack
            style={{
              fontSize: "22px",
              cursor: "pointer",
              color: customTextColor,
            }}
            onClick={handleClose}
          />

          <TextField
            id="outlined-basic"
            type="text"
            variant="outlined"
            placeholder="Search by Name"
            size="small"
            sx={{ backgroundColor: "#fff", width: "40%", marginLeft: "10px" }}
            name="consultant_name"
            value={searchName || ""}
            onChange={(event) => {
              setSearchName(event.target.value);
            }}
          />
          <button
            style={{
              border: "none",
              borderRadius: "3px",
              backgroundColor: "#3856a6",
              color: "#fff",
              width: "auto",
              padding: "7px 20px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={handleOnClickAddCandidate}
          >
            Add New
          </button>
        </span>
        <span style={{ textAlign: "right" }}>
          <Typography> Leverage Credit</Typography>
          <Typography sx={{ fontSize: "22px !important" }}>
            <b>{allCandiadate?.total_earned_credit_from_all_candidate}</b>
          </Typography>
        </span>
      </Offcanvas.Header>
      {/* <Offcanvas.Body
        style={{ paddingTop: "0", overflowY: "auto", maxHeight: "80vh" }}
        onScroll={handleScroll}
      >
        {candidateStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 50,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : allCandiadate?.profiles?.length > 0 ? (
          allCandiadate?.profiles?.map((candidate) => {
            return (
              <CandidateListCard
                candidate={candidate}
                handleOnClickJobID={handleOnClickJobID}
              />
            );
          })
        ) : (
          <h6 style={{ marginTop: "50px", textAlign: "center" }}>
            No Candidate Found
          </h6>
        )}

        {candidateStatus === "loading" && page > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 30,
              marginTop: "60px",
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        )}
      </Offcanvas.Body> */}
      <Offcanvas.Body
        id="offcanvasScroll"
        style={{ paddingTop: "0", overflowY: "auto", maxHeight: "80vh" }}
      >
        {candidateStatus === "loading" && page === 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 50,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        )}

        {allCandiadate?.profiles?.length > 0 ? (
          <InfiniteScroll
            dataLength={candidates.length}
            next={() => {
              if (allCandiadate?.has_next) {
                const nextPage = page + 1;
                setPage(nextPage);
                fetchCandidates(searchName, nextPage);
              }
            }}
            hasMore={allCandiadate?.has_next}
            loader={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 30,
                  marginTop: "20px",
                }}
              >
                <CircularProgress size={30} color="info" />
              </Box>
            }
            scrollableTarget="offcanvasScroll"
            scrollThreshold={0.9}
          >
            {candidates.map((candidate) => (
              <CandidateListCard
                key={candidate.id}
                candidate={candidate}
                handleOnClickJobID={handleOnClickJobID}
              />
            ))}
          </InfiniteScroll>
        ) : candidateStatus !== "loading" ? (
          <h6 style={{ marginTop: "50px", textAlign: "center" }}>
            No Candidate Found
          </h6>
        ) : null}
      </Offcanvas.Body>

      <CandidateDetailsViewDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={showDetails}
        row={submisionRow}
        handleOnClickEditCandidate={handleOnClickEditCandidate}
      />
      <AddCandidateDrawer
        handleShow={handleShowAddCandidate}
        handleClose={handleCloseShowAddCandidate}
        show={showAddCandidate}
        row={submisionRow}
        candidateType={candidateType}
      />
    </Offcanvas>
  );
};

export default CandidateListDrawer;
